module.exports = __webpack_public_path__ + "static/media/technology_cn3.04df5fba.png";